import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import { blue } from "./utils/Colors";

// A custom theme for this app
const theme = createTheme({
  shape: { borderRadius: 8 },
  palette: {
    primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: "Poppins",
    h1: {
      fontSize: "48px",
      fontWeight: "600",
      lineHeight: "72px",
    },
    h2: {
      fontSize: "40px",
      fontWeight: "600",
      lineHeight: "60px",
    },
    h3: {
      fontSize: "32px",
      fontWeight: "600",
      lineHeight: "48px",
    },
    h4: {
      fontSize: "28px",
      fontWeight: "600",
      lineHeight: "42px",
    },
    h5: {
      fontSize: "24px",
      fontWeight: "600",
      lineHeight: "36px",
    },
    h6: {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "30px",
    },
    overline: {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "27px",
    },
    body1: {
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
    },
    body2: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
    },
    subtitle1: {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "21px",
    },
    subtitle2: {
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "18px",
    },
    allVariants: { color: blue[900] },
  },
});

export default theme;
